import { IBaseDataParser } from "../../../core/src/server/parsers/IBaseDataParser";
import IAuthorizationData from "../../../core/src/server/data/IAuthorizationData";

import GameModel from "../../../core/src/model/GameModel";
import JackpotsModel from "../../model/JackpotsModel";
import App from "../../../core/src/App";
import GameEvents from "../../../core/src/const/GameEvents";
import BetModel from "../../../core/src/model/BetModel";

export default class SessionDataParser
    implements IBaseDataParser<IAuthorizationData> {

    // this is for Fantasma prototype server
    check(data: any): boolean {
        return false;
    }

    parse(data): IAuthorizationData[] {
        const result = {};
        return [result];
    }


}
